export const SKILLS_DEVELOPMENT_METHODS = ['advisors', 'courses'] as const;
export type SkillsDevelopmentMethod = typeof SKILLS_DEVELOPMENT_METHODS[number];
